export default __webpack_public_path__ + "static/media/manager.682b5625.svg";